import { Select } from "antd"
import { useState, useEffect } from 'react'
import req from '../request'
const App = props => {
    const [options, setOptions] = useState([])
    const getOptions = () => [
        req.post('/api/return', { action: 'getStatus' }).then(r => {
            // console.log(r);
            setOptions(r)
        })
    ]
    const handleChange = t => {
        props.onChange && props.onChange(t)
    }
    useEffect(() => {
        getOptions()
    }, [])
    return <Select
        allowClear
        showSearch
        value={props.value ? props.value : null}
        style={{ width: 200 }}
        placeholder='请选择状态'
        options={options}
        onChange={handleChange}
        filterOption={(input, option) => {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }}
    >
    </Select>
}
export default App